<template>
    <BaseLink
        :class="$style.profile"
        :to="{ name: ROUTE_NAMES.PROFILE }"
        data-interface-target="profile-link"
    >
        <Icon name="silver_fennec_coin_small" />
        <Typography
            type="label"
            size="l"
            semibold
            :class="$style.balance"
            :responsive="false"
        >
            <Balance :balance="props.userBalance" />
        </Typography>
        <UserAvatar
            :class="$style.avatar_override"
            :avatar="props.user.avatar"
            :firstName="props.user.firstName"
            :lastName="props.user.lastName"
        />
    </BaseLink>
</template>
<script setup lang="ts">
import Balance from '@/components_new/Balance.vue'
import BaseLink from '@/components_new/BaseLink.vue'
import Icon from '@/components_new/Icon/Icon.vue'
import Typography from '@/components_new/Typography.vue'
import UserAvatar from '@/components_new/UserAvatar.vue'
import { ROUTE_NAMES } from '@/router/constants'
import { User } from '@/types'

const props = defineProps<{
    user: User
    userBalance: number
    isProfilePage: boolean
}>()
</script>
<style module>
.profile {
    border-radius: 1000px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: var(--carbon-400);
    padding: 8px 8px 8px 12px;
    gap: 8px;
}

.profile:hover,
.profile:focus {
    box-shadow: 0px 0px 30px 0px rgba(163, 109, 253, 0.64) inset;
    outline: 0.5px solid var(--purple-300);
}
.avatar_override {
    width: 36px;
    height: 36px;
}
</style>
